import i18n from '@/i18n'
import { Values } from 'vue-i18n'

export default (key: string, values?: Values): string => i18n.t(key, values) as string
